<template>
    <fragment>
        <div
            class="flex flex-wrap md:flex-row flex-col-reverse items-end w-full"
        >
            <div class="w-full md:w-3/4 md:p-0 mx-auto">
                <div class="w-full flex items-end">
                    <custom-search
                        :label="label"
                        :display-value="itemCurrent.name"
                        :disabled="!enabled"
                        placeholder="Buscador de productos"
                        :fetch-items="searchInventoryItems"
                        @select="selectProduct"
                        @focus="emitFocus"
                        @blur="onBlur"
                    >
                        <template #item="{ item }">
                            <span class="flex justify-between">
                                <span>{{ item.name | cut(50) }}</span>
                                <span>{{ item.priceOffer | money }}</span>
                            </span>
                        </template>
                    </custom-search>
                    <div class="flex justify-center">
                        <slot name="complement"></slot>
                    </div>
                </div>
            </div>
            <div class="w-full md:w-1/4">
                <div
                    class="w-full flex justify-center lg:flex-row flex-col-reverse"
                >
                    <barcode-scanner
                        v-model="isEnabledScanner"
                        :enabled="enabled"
                        @input="searchByBarcode"
                    />
                </div>
            </div>
        </div>

        <product-reference-modal
            v-model="openModalReferences"
            :product-name="productTmp.name"
            :references="productTmp.references"
            :reference-selected="referenceSelected"
            @close="isEnabledScanner = true"
            @select="selectReference"
        />
    </fragment>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import BarcodeScanner from "@/components/utils/BarcodeScanner.vue";
import CustomSearch from "@/components/utils/CustomSearch.vue";
import ProductReferenceModal from "@/components/utils/ProductReferenceModal.vue";

export default {
    name: "InventoriesSearchScanner",
    components: { BarcodeScanner, ProductReferenceModal, CustomSearch },
    model: {
        prop: "itemCurrent",
        event: "input"
    },
    props: {
        defaultFilters: {
            default: () => ({
                active: true
            }),
            type: Object,
            required: false
        },
        itemCurrent: {
            default: () => ({ name: "" }),
            type: Object,
            required: false
        },
        label: {
            default: () => "",
            type: String,
            required: false
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        },
        enabledScanner: {
            default: () => true,
            type: Boolean,
            required: false
        },
        autoFocus: {
            default: () => false,
            type: Boolean,
            required: false
        }
    },
    emits: ["blur", "focus", "input"],
    data: () => ({
        isEnabledScanner: true,
        openModalReferences: false,
        referenceSelected: null,
        productTmp: {
            id: 0,
            sku: "",
            slug: "",
            name: "",
            references: []
        }
    }),
    computed: {
        ...mapState("commons", ["selectedMerchant"]),
        ...mapGetters("control", ["backgroundColor"])
    },
    watch: {
        enabledScanner(value) {
            this.setEnabledScanner(value);
        }
    },
    mounted() {
        this.setEnabledScanner(this.enabledScanner && !this.autoFocus);
    },
    methods: {
        ...mapActions("inventories", ["searchInventories"]),
        searchInventoryItems(keyword, required = false) {
            return this.searchInventories({
                ...this.defaultFilters,
                merchantType: this.selectedMerchant.merchantType,
                merchantId: this.selectedMerchant.merchantId,
                keyword,
                required
            });
        },
        async searchByBarcode(barcode) {
            try {
                const itemsAux = await this.searchInventories({
                    ...this.defaultFilters,
                    merchantType: this.selectedMerchant.merchantType,
                    merchantId: this.selectedMerchant.merchantId,
                    barcode
                });
                if (itemsAux.length > 0) {
                    this.selectProduct(itemsAux[0]);
                }
            } catch (error) {
                this.$sound.play("error");
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        onBlur() {
            this.$emit("blur");
        },
        emitFocus() {
            this.isEnabledScanner = true;
            this.$emit("focus");
        },
        setEnabledScanner(value) {
            this.isEnabledScanner = Boolean(value);
        },
        async selectProduct(product) {
            this.productTmp = { ...product };
            if (product.references.length === 0) {
                await this.$swal.fire({
                    icon: "error",
                    title: "Producto invalido",
                    text: "Entra a los detalles del producto y verifica que tenga referencias"
                });
                window
                    .open(`/app/products/detail/${product.id}`, "_blank")
                    .focus();
            } else if (product.references.length === 1 || this.any) {
                this.validatePush(product.references[0], product);
                this.openModalReferences = false;
                this.referenceSelected = -1;
                this.isEnabledScanner = true;
                this.removeHandlerKey();
            } else {
                this.isEnabledScanner = false;
                this.productTmp = { ...product };
                this.referenceSelected = -1;
                this.openModalReferences = true;
                this.addHandlerKey();
            }
        },
        validatePush(reference, product) {
            this.$emit("input", {
                ...reference,
                appliedDiscountPerReference: 0,
                product: {
                    id: product.id,
                    sku: product.sku,
                    slug: product.slug,
                    name: product.name
                }
            });
            this.referenceSelected = -1;
        },
        pushReference() {
            if (this.referenceSelected < 0) return;
            const reference =
                this.productTmp.references[this.referenceSelected];
            this.validatePush(reference, this.productTmp);
            this.removeHandlerKey();
            this.openModalReferences = false;
            this.referenceSelected = -1;
            this.isEnabledScanner = true;
        },
        selectReference(index) {
            if (index < 0) {
                return;
            }
            this.isEnabledScanner = false;
            this.referenceSelected = index;
            this.pushReference();
        },
        incrementReferenceSelect() {
            this.isEnabledScanner = false;
            if (!this.openModalReferences) return;
            if (this.referenceSelected < 0) {
                this.referenceSelected = 0;
            } else if (
                this.referenceSelected <
                this.productTmp.references.length - 1
            ) {
                this.referenceSelected = this.referenceSelected + 1;
            }
        },
        decrementReferenceSelect() {
            this.isEnabledScanner = false;
            if (!this.openModalReferences) return;
            if (this.referenceSelected < 0) {
                this.referenceSelected = 0;
            } else if (this.referenceSelected > 0) {
                this.referenceSelected = this.referenceSelected - 1;
            }
        },

        handleKey(event) {
            const actions = {
                Enter: this.pushReference,
                Escape: this.closeReferenceModal,
                ArrowUp: this.decrementReferenceSelect,
                ArrowDown: this.incrementReferenceSelect
            };
            const fun = actions[event.key] || function () {};
            fun();
        },
        closeReferenceModal() {
            this.openModalReferences = false;
            this.isEnabledScanner = true;
        },
        removeHandlerKey() {
            document.removeEventListener("keydown", this.handleKey);
        },
        addHandlerKey() {
            document.addEventListener("keydown", this.handleKey);
        },
        onBlurSomeInput() {
            this.isEnabledScanner = true;
            this.addHandlerKey();
        },
        onFocusSomeInput() {
            this.isEnabledScanner = false;
            this.removeHandlerKey();
        }
    }
};
</script>
